import { MemberType } from "../../Enums/PersonEnums";
import { IPerson } from "../../interfaces";

export const PersonEmpty: IPerson = {
    id: "",
    memberType: MemberType.member,
    firm: "",
    firmName: "",
    externalType: "",
    submittedBy: "",
    generatedId: 0,
    photo: "",
    name: "",
    middleInitial: "",
    lastName: "",
    suffix: "",
    honorary: "",
    title: undefined,
    unlistedTitle: "",
    unlistedTitleToggle: false,
    listTitle: "",
    listingCategory: "",
    countryCodePhoneNumber: "",
    phoneNumber: "",
    phoneBaseCode: "",
    directCountryCodePhoneNumber: "",
    directPhoneNumber: "",
    directPhoneBaseCode: "",
    displayName: "",
    isSearchable: false,
    isAttorney: false,
    hasAssistant: false,
    assistantName: "",
    assistantEmail: "",
    firmEmail: "",
    mainOffice: "",
    mainOfficeName: "",
    mainContact: false,
    profileURL: "",
    socialNetworks: [],
    additionalOffices: [],
    bio: "",
    languages: [],
    barAdmissions: [],
    education: "",
    areasOfPractice: [],
    significantAccomplishments: "",
    industryOrganizationAffiliation: [],
    professionalActivitiesAndPreviousExperience: "",
    additionalActivities: "",
    seminarPresentation: "",
    additionalInformation: "",
    userId: "",
    _ts: 0,
  };
